import React from 'react';
import './AboutUs.css';

function AboutUs() {
  return (
    <div className="about-us-container">
      <h1>About JALM</h1>

      <section className="about-section">
        <p>
          JALM (Just A Little Market) is designed with simplicity and practicality at its heart, empowering
          small and mid-range business owners to generate invoices effortlessly. Whether you're running a
          bustling local grocery store, a corner tech outlet, or a neighborhood shop, JALM helps streamline
          your billing process while reducing manual effort and avoiding accounting headaches. It's not just
          software—it’s your smart companion for everyday trade.
        </p>
      </section>

      <section className="about-section">
        <p>
          Tailored to serve multiple business domains like Supermarkets, Tech Retail Stores, and more, JALM is
          built with scalability in mind. Business owners can manage products, track purchases, calculate taxes,
          and produce polished invoices—within minutes. The intuitive interface adapts to your workflow, whether
          you're on desktop or mobile, so you don’t have to wrestle with complicated systems or expensive software
          suites.
        </p>
      </section>

      <section className="about-section">
        <p>
         JALM offers flexible invoice generation with a variety of stylish formats like Default, Classic, Blue & Black,
          Table, Professional, Modern Minimalist, Classic Table and more. These diverse templates make it easy for users to choose
           their preferred layout for presenting billing details clearly and professionally. All invoices are automatically
            generated in PDF format with predefined information, streamlining the process for faster and consistent output.
        </p>
      </section>

      <section className="about-section">
        <p>
         Additionally, JALM allows users to tailor their cart by adjusting prices to suit individual requirements. 
         Items can be removed effortlessly from the cart if no longer needed, ensuring accurate billing and
          a customizable checkout experience. This user-friendly approach makes it ideal for businesses seeking
           both versatility and efficiency in their invoicing workflow.
        </p>
      </section>

      
      <section className="about-section">
        <p>
          What truly sets JALM apart is its communication-friendly invoicing: once your invoice is ready, you can
          instantly share it with customers via WhatsApp, email, or other platforms, making checkout not only
          efficient but professional and customer-centric. JALM is more than a billing tool—it’s a promise to help
          small businesses thrive with technology that’s fast, fuss-free, and future-ready.
        </p>
      </section>
    </div>
  );
}

export default AboutUs;
